module.exports = __webpack_public_path__ + "5f7798ab659857d819a324ceb9db829a.png";